<template>
  <div class="home-page">
    <home-page-holiday-promo-banner v-if="isHolidayPromoEnabled" />
    <home-page-hero v-else />
    <home-page-hignlighted />
    <home-page-media-quotes />
    <home-page-cta />
    <home-page-f-a-q />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageMixin from '../../shared/pageMixin';
import HomePageCTA from '../../components/webv2/homeexp/HomePageCTA';
import HomePageHero from '../../components/webv2/homeexp/HomePageHero';
import HomePageHignlighted from '../../components/webv2/homeexp/HomePageHignlighted';
import HomePageMediaQuotes from '../../components/webv2/homeexp/HomePageMediaQuotes';
import HomePageFAQ from '../../components/webv2/homeexp/HomePageFAQ';
import HomePageHolidayPromoBanner from '../../components/webv2/homeexp/HomePageHolidayPromoBanner';

export default {
  name: 'Home',
  components: {
    'home-page-cta': HomePageCTA,
    'home-page-hero': HomePageHero,
    HomePageHignlighted,
    HomePageMediaQuotes,
    HomePageFAQ,
    HomePageHolidayPromoBanner,
  },
  mixins: [PageMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'isHolidayPromoEnabled',
    ]),
  },
  mounted() {
    this.setMetaInformation('Luminary | Listen to Luminary Original Podcasts', 'Luminary is a subscription podcast network with an award-winning collection of original shows you won\'t find anywhere else. Start your 7-day free trial today!');
  },
  destroyed() {
    this.setMetaInformation();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.home-page {
  background-color: $bg-color;
  font-family: $patron !important;
  /deep/ button {
    font-family: $patron;
  }
}
</style>
